import type { PerformanceBand } from "newui/features/MySuppliers/types/supplier-performance.types";

export const DIAL_SEGMENTS = 9;
export const START_ANGLE = Math.PI; // 180 degrees (left side)
export const END_ANGLE = 0; // 0 degrees (right side)
export const SEGMENT_GAP = 0.02; // radians between segments

export const SEGMENT_BAND_MAP: PerformanceBand[] = [
	"red",    // 1
	"red",    // 2
	"amber",  // 3
	"amber",  // 4
	"amber",  // 5
	"blue",   // 6
	"blue",   // 7
	"green",  // 8
	"green",  // 9
];

export const BAND_HEX_COLORS: Record<PerformanceBand, string> = {
	red: "#EF4444",
	amber: "#F59E0B",
	blue: "#3B82F6",
	green: "#22C55E",
};

export const BAND_LABEL: Record<PerformanceBand, string> = {
	red: "Low",
	amber: "Moderate",
	blue: "Strong",
	green: "Exemplary",
};

export const SIZE_DIMENSIONS: Record<string, { strokeWidth: number; width: number; fontSize: number; height: number; }> = {
	sm: { width: 120, height: 70, strokeWidth: 14, fontSize: 14 },
	md: { width: 180, height: 100, strokeWidth: 18, fontSize: 18 },
	lg: { width: 240, height: 130, strokeWidth: 22, fontSize: 22 },
};
